import { Component, Input } from '@angular/core';

import { IQuickbetSelectionResponseModel } from '../../../quickbet/models/quickbet-selection-response.model';

@Component({
    selector: 'srm-quickbet-panel-wrapper',
    templateUrl: 'srm-quickbet-panel-wrapper.component.html',
    standalone: false,
})
export class SrmQuickbetPanelWrapperComponent {
    @Input() selection: IQuickbetSelectionResponseModel;
    @Input() betslipType: string;
    @Input() isSRMBet: boolean;
    @Input() selectedQuestionAndAnswers: boolean;
    @Input() srmOdds: boolean;
    @Input() srmSelectedChannels: [];
    @Input() selectionEventLocalTime: string;
}
